import tools from "../../tools";
//导入draggable组件
import draggable from 'vuedraggable'


let token = tools.getCookie('localtoken');
var indent = '\t'; //tab
export default {
    name: 'Chapter',
    //注册draggable组件
    components: {
        draggable,
    },
    props: ['exercisePoolId', 'IsEditor', 'isOCRExercisePool'],
    data() {
        return {
            exerciseContentsId: "", //目录内容id
            exercisePoolChapterList: [],
            activeChapterId: 0, //0是目录，有值是章节id,-1非OCR题库显示全部章节

            isEditorCatalog: false, //是否编辑目录状态
            isShowTextarea: false,
            isShowCatalogJsonList: false, //是否显示目录预览模态框
            catalogJsonList: [], //整理出的章节集合，用于模态框显示校对

            //添加章节
            isAddNewChapter: false, //是否是添加章
            addNewChapterName: "", //新章名
            addNewChapterPage: "", //新章页码

            //添加小节
            addSubChapterName: "", //小节名
            addSubChapterPage: "",//小节页码

            //章节右键菜单
            isShowContextMenu: false,//是否显示右键后的列表
            contextMenuLeft: 0,//右键弹出后定位
            contextMenuTop: 0,//同上
            contextMenuOne: "", //右键的对象
            contextMenuGrade: 0, //等级 章=1，节=2，小节=3
            contextMenuDom: "", //右键的dom元素
            contextMenuDirection: "", //插入方式 before/after

            drag: false, //拖拽操作
            dragItem: "", //拖拽的对象

            Genre:1, //暂时留着 判断是什么版本的录入
          //  isjing:false,
            visible:false,  //没什么用，京版加的
            addHtepaperf:false,//是否是添加试卷
            //新调序字段
            EChapterId:"", //当前章节id
            ParentId:"",   //父节点id
            Sequence:"",   //当前节点排在第几位，从1开始
            Grade:'',   //节点排在第几级，目前三级 从1开始
            voiceshow:false,//是否显示音频标签
            havevoice:false,
            //划过
            linkvoice:'',//关联音频的名字
            linkvoiceId:'',//关联音频名字
            allhavevoicebank:false,
        }
    },
    created() { 
        let that = this;
        that.init();
    },
    mounted: function () {
        let that = this;
        $(document).on('click', 'body', function () {
            that.isShowContextMenu = false;
        });
        this.checkallVoice();
    },
    updated: function () {

    },
    methods: {
        init: function () {
            let _this = this;
            _this.getExercisePool();
            _this.getPoolChapter();
        },
        //获取题库
        getExercisePool: function () {
            let _this = this;
            tools.api('ExercisesPool.GetExercisePoolInfoAsync', {"poolid": _this.exercisePoolId}, (data) => {
                _this.exerciseContentsId = data.ExerciseContentsId;
            });
        },
        //获取题库章节
        async getPoolChapter() {
            let _this = this;
            let ChapterInputStatus = await getChapterInputStatus();
            tools.api('ExercisesPool.SearchPoolChapterAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                if (data.length <= 0) {
                    _this.exercisePoolChapterList = [];
                } else {
                    //拼接章节录题状态
                    data.forEach(function (item2) {
                        item2.InputStatus = false;
                    })
                    for (let item of ChapterInputStatus) {
                        data.forEach(function (item2) {
                            if (item2.HexID == item.chapterId) {
                                item2.InputStatus = item.inputStatus;
                            }
                        })
                    }
                    
                    for (let item of data) {
                        item.isEditorChapter = false; //是否编辑章节
                        item.isAddSubChapter = false; //是否添加子节
                       
                        item.subChapterList = [];
                        item.subChapterList = data.filter(function (sub) {
                            return item.HexID == sub.ParentID
                        })
                        if (item.subChapterList.length > 0) {
                            item.isShowSub = true; //默认展开
                        }
                    }

                    _this.exercisePoolChapterList = data.filter(function (item) {
                        return item.IsParent == true;
                    });

                    //计算父章节录题状态
                    for (let item of _this.exercisePoolChapterList) {
                        if (item.subChapterList.length > 0) {
                            for (let sub of item.subChapterList) {
                                if (sub.subChapterList.length > 0) {
                                    let subInputStatus = sub.subChapterList.filter(function (state) {
                                        return state.InputStatus == true
                                    })
                                    if (subInputStatus.length == sub.subChapterList.length) {
                                        sub.InputStatus = true
                                    } else {
                                        sub.InputStatus = false;
                                    }
                                }
                            }

                            let InputStatus = item.subChapterList.filter(function (state) {
                                return state.InputStatus == true
                            })
                            if (InputStatus.length == item.subChapterList.length) {
                                item.InputStatus = true
                            } else {
                                item.InputStatus = false;
                            }
                        }
                    }
                }

                //选中章节规则
                //1:默认选中之前选择的小节. 2:编辑情况下，默认选中目录. 3:完成编辑后，显示第一小节
                //默认选中之前存的小节，包括0=目录，-1=全部章节
                let activeChapterId = 0;
                let getCookieChapterId = tools.getCookie("ExpoolActiveChapterId" + _this.exercisePoolId);
                if (getCookieChapterId && !isNaN(parseInt(getCookieChapterId))) {
                    activeChapterId = parseInt(getCookieChapterId);
                    //如果非OCR默认选中编辑目录，则默认选中全部章节
                    if (activeChapterId == 0 && !_this.isOCRExercisePool && !_this.isEditorCatalog) {
                        activeChapterId = -1;
                    }
                } else if (_this.exercisePoolChapterList.length > 0) {
                    //默认选中第一个小节，只取第一个就够了
                    let item = _this.exercisePoolChapterList[0];
                    if (item.subChapterList.length > 0) {
                        let sub = item.subChapterList[0];
                        if (sub.subChapterList.length > 0) {
                            activeChapterId = sub.subChapterList[0].HexID;
                        } else {
                            activeChapterId = sub.HexID;
                        }
                    } else {
                        activeChapterId = item.HexID;
                    }
                } else if (!_this.isOCRExercisePool) {
                    //不是OCR题库，没有章节，则默认选中全部章节
                    activeChapterId = -1;
                }
                _this.changeActiveChapterIndex(activeChapterId);


        
               _this.setlevel(this.exercisePoolChapterList)


            })
            //获取章节录入状态
            function getChapterInputStatus() {
                return new Promise(function (resolve, reject) {
                    tools.api('OCR.SearchEChapterStatusAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                        let json = [];
                        for (let item of data) {
                            json.push({
                                "chapterId": item.EChapterId,
                                "inputStatus": item.MarkStatus == 4 ? true : false
                            });
                        }
                        resolve(json);
                    }, function () {
                        resolve([]);
                    });
                })
            }
        //   console.log(this.exercisePoolChapterList)
        },
        setlevel(data){
            const renderTree = (data, level) => {
                return data.map((item) => {
                  item.level = level;
                  if (item.subChapterList) {
                    renderTree(item.subChapterList, level + 1);
                  }
                });
              };
            renderTree(data, 1);

            this.exercisePoolChapterList = data;
        } , 
        //添加试卷
        addHtepaper(item){
            this.addHtepaperf = true
            let _this = this;
            _this.clearEditorChapterState();
            item.isAddSubChapter = true;
            this.addSubChapterName = "";
            this.addSubChapterPage = "";
            this.$nextTick(function () {
                $('.content input[type="text"]').focus();
            })
        },


        //更改当前选中章节
        changeActiveChapterIndex: function (id) {
            var allcookie = [];
            let _this = this;
            _this.activeChapterId = id;
            _this.isvoicechp(id)
            //录入下节需要刷新后显示之前选中的节，而不是一直是第一节
            //过几个月记得删掉这一段
            if (document.cookie && document.cookie != '') {
                let cookies = document.cookie.split(';');
                cookies.forEach((i,n)=>{
                    if(i.slice(1,19)=='ExpoolActiveChapte'){
                        console.log(i.split('=')[0])
                        tools.deleteCookie2(i.split('=')[0])
                    }
                })
            }
            tools.setCookie2("ExpoolActiveChapterId" + _this.exercisePoolId, _this.activeChapterId);
            _this.changeChapterComponents();
        },
        //切换小节显示
        changeTreeShow: function (item) {
            item.isShowSub = !item.isShowSub;
        },
        //切换章节编辑状态
        changeEditorCatalog: function () {
            this.isEditorCatalog = !this.isEditorCatalog;
            this.changeEditorCatalogComponents();
            $("#insert").remove();
            if (this.isEditorCatalog) {
                //初始化编辑·
                this.isAddNewChapter = false;
                this.addNewChapterName = "";
                this.addNewChapterPage = "";
                //默认显示目录
                this.changeActiveChapterIndex(0);
                this.clearEditorChapterState();
            } else {
                //编辑完成，默认选中第一小节 。 清除之前的选中存值
                tools.deleteCookie("ExpoolActiveChapterId" + this.exercisePoolId);

                let choosedNodes = document.querySelectorAll('input.itemCheck:checked')
                choosedNodes.forEach(oneNode => {
                    oneNode.checked = false
                })
                
                //清除选取
                this.clearCatalogValue();
                $(".shadows").remove();
                this.getPoolChapter();
            }
        },

        //设置文字 【3】代表页码(中文【】)
        setCatalogValue: function (data) {
            let html = $("textarea").val(); //追加文本
            for (let item of data) {
                if (item.content.length > 0) {
                    if (item.level == 0) {
                        html += item.content + '【' + item.page + '】\n';
                    } else if (item.level == 1) {
                        html += indent + item.content + '【' + item.page + '】\n';
                    } else {
                        html += indent + indent + item.content + '【' + item.page + '】\n';
                    }
                }
            }
            $("textarea").val(html);
        },
        //模拟tab事件
        tab: function ($ev) {
            let $this = $ev.target;

            let start = $this.selectionStart;
            let end = $this.selectionEnd;
            let selected = window.getSelection().toString();
            if (($ev.shiftKey) && ($ev.keyCode === 9)) {
                console.log("shift Tab");
                event.stopPropagation();
                event.preventDefault();
                //减tab
                if (selected.indexOf(indent) == 0) {
                    //第一行有tab，减去
                    selected = selected.substr(1);
                }
                selected = selected.replace(/\n\t/g, '\n');
                $this.value = $this.value.substring(0, start) + selected + $this.value.substring(end);
                //神奇的是必须setTimeout才能定位光标
                setTimeout(function () {
                    $this.setSelectionRange(start, start + selected.length);
                    $this.focus();
                }, 0);
            } else if ($ev.keyCode === 9) {
                console.log("Tab");
                //加tab
                selected = indent + selected.replace(/\n/g, '\n' + indent);
                $this.value = $this.value.substring(0, start) + selected + $this.value.substring(end);
                //神奇的是必须setTimeout才能定位光标
                setTimeout(function () {
                    $this.setSelectionRange(start + indent.length, start + selected.length);
                    $this.focus();
                }, 0);
            }
        },
        //获取文字
        getCatalogValue: function () {
            let _this = this;
            let catalogText = $("textarea").val();
            if (catalogText.length <= 0) {
                tools.alertwar("请输入内容！");
                return false;
            }
            let isResult = true;
            let errorResultIndex = []; //记录错误是几行，行数
            //章节，等级，页码
            let catalogJsonList = [];
            let pageCheck = "";
            let catalogTextList = catalogText.split("\n");
            catalogTextList.forEach(function (item, index) {
                //录入目录内容文字间支持加Tab： 中间的tab不能去除，只能检验头部有几个tab
                let tabheader = item.match(/^\t*/g)[0]; //获取头部的几个tab
                let grade = tabheader.split(indent).length;
                item = item.replace(tabheader, '');
                if (item.length > 0) {
                    let temp;
                    if (_this.isOCRExercisePool) {
                        temp = _this.getRegular(item, grade);
                    } else {
                        temp = _this.getRegularNoPage(item, grade);
                    }
                    if (temp.result) {
                        catalogJsonList.push({
                            "EChapterName": temp.text,
                            "EChapterGrade": grade, //1,2,3
                            "PageStart": temp.page
                        });
                    } else {
                        isResult = false;
                        pageCheck += temp.message;
                        errorResultIndex.push(index);
                    }
                }
            })
            //校验页面是否填写
            if (!isResult) {
                tools.alertwar(pageCheck);
                _this.scrollTextarea(errorResultIndex);
                return false;
            }

            //设置 Number 和 ParentNumber(给接口传父子关系)
            for (let i = 0; i < catalogJsonList.length; i++) {
                catalogJsonList[i].Number = i + 1;
            }
            //将头部非一级目录追加到已有章节下
            if (catalogJsonList.length > 0 && catalogJsonList[0].EChapterGrade != 1 && _this.exercisePoolChapterList.length > 0) {
                let ParentNumberGrade1 = 0; //最后一个章ID
                let ParentNumberGrade2 = 0; //最后一个节ID
                //已有目录，获取最后一个章&节
                let chapterItem = _this.exercisePoolChapterList[_this.exercisePoolChapterList.length - 1];
                ParentNumberGrade1 = chapterItem.HexID;
                if (chapterItem.subChapterList && chapterItem.subChapterList.length > 0) {
                    let sectionItem = chapterItem.subChapterList[chapterItem.subChapterList.length - 1];
                    ParentNumberGrade2 = sectionItem.HexID;
                }
                //将目录追加到已有章节下
                for (let i = 0; i < catalogJsonList.length; i++) {
                    if (catalogJsonList[i].EChapterGrade == 1) {
                        break;
                    }
                    if (catalogJsonList[i].EChapterGrade == 2) {
                        catalogJsonList[i].ParentEChapterId = ParentNumberGrade1;
                        catalogJsonList[i].ParentNumber = 0;
                        for (let z = i + 1; z < catalogJsonList.length; z++) {
                            if (catalogJsonList[z].EChapterGrade == 2) {
                                break;
                            }
                            if (catalogJsonList[z].EChapterGrade == 3) {
                                catalogJsonList[z].ParentNumber = catalogJsonList[i].Number;
                            }
                        }
                    }
                    if (catalogJsonList[i].EChapterGrade == 3 && catalogJsonList[i].ParentNumber == undefined) {
                        catalogJsonList[i].ParentEChapterId = ParentNumberGrade2;
                        catalogJsonList[i].ParentNumber = 0;
                    }
                }
            }

            for (let i = 0; i < catalogJsonList.length; i++) {
                if (catalogJsonList[i].EChapterGrade == 1) {
                    catalogJsonList[i].ParentNumber = 0;
                    for (let j = i + 1; j < catalogJsonList.length; j++) {
                        if (catalogJsonList[j].EChapterGrade == 1) {
                            break;
                        }
                        if (catalogJsonList[j].EChapterGrade == 2) {
                            catalogJsonList[j].ParentNumber = catalogJsonList[i].Number;
                            for (let z = j + 1; z < catalogJsonList.length; z++) {
                                if (catalogJsonList[z].EChapterGrade == 2) {
                                    break;
                                }
                                if (catalogJsonList[z].EChapterGrade == 3) {
                                    catalogJsonList[z].ParentNumber = catalogJsonList[j].Number;
                                }
                            }
                        }
                    }
                }
            }
            //校验父节点
            let parentNodeCheck = "";
            for (let i in catalogJsonList) {
                if (catalogJsonList[i].ParentNumber == undefined) {
                    parentNodeCheck += "<p>" + catalogJsonList[i].EChapterName + ",没有上级目录!</p>";
                    isResult = false;
                    errorResultIndex.push(i);
                }
            }
            //拦截提交接口
            if (!isResult) {
                tools.alertwar(parentNodeCheck);
                _this.scrollTextarea(errorResultIndex);
                return false;
            }

            if (_this.isOCRExercisePool) {
                //校验页码需>=前一个页码
                let minPageCheck = "";
                let minPage = 1;
                if (_this.exercisePoolChapterList.length > 0) {
                    //已有目录，则最小页码应该是已有最大页码
                    let minItem = _this.exercisePoolChapterList[_this.exercisePoolChapterList.length - 1];
                    minItem.subChapterList.forEach(function (sub) {
                        minItem = sub;
                        sub.subChapterList.forEach(function (sub2) {
                            minItem = sub2;
                        })
                    })
                    minPage = parseInt(minItem.PageCount);
                }
                catalogJsonList.forEach(function (item, index) {
                    if (item.PageStart >= minPage) {
                        minPage = item.PageStart;
                    } else {
                        minPageCheck += "<p>" + item.EChapterName + ",页码不能小于" + minPage + "!</p>";
                        isResult = false;
                        errorResultIndex.push(index);
                    }
                })
                //拦截提交接口
                if (!isResult) {
                    tools.alertwar(minPageCheck);
                    _this.scrollTextarea(errorResultIndex);
                    return false;
                }
            }
            window.burryPointHandler({'catalogJsonList': catalogJsonList}, 'UCT2_4_2')
            _this.isShowCatalogJsonList = true;
            _this.catalogJsonList = catalogJsonList;
        },
        //滚动到对应位置 ，方便提示错误信息
        scrollTextarea: function (index) {
            let indexList = [].concat(index);
            let scrollHeight = 22 * indexList[0]; //行高22 行从0开始
            $("textarea").animate({scrollTop: scrollHeight}, 1000);
        },
        closeCatalogJsonList: function () {
            this.isShowCatalogJsonList = false;
        },
        //修改
        submitCatalogJsonList: function () {
            let _this = this;
            //编辑完成，默认选中第一小节 。 清除之前的选中存值
            tools.deleteCookie("ExpoolActiveChapterId" + _this.exercisePoolId);
            let catalogJsonList = _this.catalogJsonList;
           
            _this.savePoolChapter(catalogJsonList);
            _this.closeCatalogJsonList();
            _this.clearCatalogValue();
            _this.isEditorCatalog = false;
            _this.changeEditorCatalogComponents();
            $(".shadows").remove();
        },
        //正则处理一行数据
        getRegular: function (value, grade) {
            let result = true;
            let message = "";
            let text = value.replace(/\【(\d+)\】/g, '');
            let page = 0;
            if (/\【(\d+)\】/g.test(value)) {
                page = value.match(/\【(\d+)\】/g)[0].match(/(\d+)/g)[0];
            } else {
                //没有页码
                result = false;
                message = "<p>" + text + ",没有页码!</p>";
            }
            return {"result": result, "text": text, "page": parseInt(page), "message": message};
        },
        //正则处理一行数据 没有页码的
        getRegularNoPage: function (value, grade) {
            let result = true;
            let message = "";
            let text = value;
            let page = 0;
            return {"result": result, "text": text, "page": parseInt(page), "message": message};
        },
        //(批量)保存题库目录
        savePoolChapter: function (list) {
            let _this = this;
            _this.savePoolChapterCommon(list, -1);
        },
        //保存题库目录公共方法， parentEChapterId=-1时是ocr批量增加,parentEChapterId=0时是增加在目录下的章，parentEChapterId=值时是加载此父节点下
        savePoolChapterCommon: function (list, parentEChapterId) {
            let _this = this;
            let json = '';
            
            if(parentEChapterId==-1){
                if(_this.addHtepaperf){
                    tools.putLoading();
                   
                    tools.api('ExercisePools.CreateHtePaper', {
                        "eChapterId": parentEChapterId,
                        "htePaperName": list[0].EChapterName,
                    }, (data) => {
                       
                      //  _this.changeEChapterSequence(data, parentEChapterId);
                      _this.getPoolChapter();
                      tools.deleteLoading();
                    });
                // window.burryPointHandler({
                //     "eChapterId": parentEChapterId,
                //     "htePaperName": list[0].EChapterName,
                // }, 'UCT2_4_1')
                }else{
                    tools.putLoading();
                    tools.api('ExercisesPool.SavePoolChapterAsync', {
                        "exercisePoolId": _this.exercisePoolId,
                        "userId": tools.getCookie("UserId"),
                        "echapterList": list
                    }, (data) => {
                        
                      //  _this.changeEChapterSequence(data, parentEChapterId);
                      _this.getPoolChapter();
                      tools.deleteLoading();
                    });
                    // window.burryPointHandler({
                    //     "exercisePoolId": _this.exercisePoolId,
                    //     "userId": tools.getCookie("UserId"),
                    //     "echapterList": list
                    // }, 'UCT2_4_1')
                }
            }else{
                if(_this.addHtepaperf){
                    json={
                        "exerciseBookId":_this.exercisePoolId,
                        "eChapterName":list[0].EChapterName,
                        "parentEChapterID":list[0].ParentEChapterId,
                        "grade":list[0].EChapterGrade,
                        "isHTEPaper":true,
                        "pageStart":list[0].PageStart,
                    }
                }else{
                    json={
                        "exerciseBookId":_this.exercisePoolId,
                        "eChapterName":list[0].EChapterName,
                        "parentEChapterID":list[0].ParentEChapterId,
                        "grade":list[0].EChapterGrade,
                        "isHTEPaper":false,
                        "pageStart":list[0].PageStart,
                    }
                }
                window.burryPointHandler(json, 'UCT2_4_2')
                tools.api('ExercisePools.CreateEChapter', json, (data) => {
                   
                   _this.getPoolChapter();
                   tools.deleteLoading();
                });
            }
            
        },
        //章节排序接口，只有添加章节时调用
        changeEChapterSequence: function (newId, parentEChapterId) {
            let _this = this;
            let EChapterIds = [];
            if (parentEChapterId != -1 && parentEChapterId != 0) {
                //找到父节点追加
                _this.exercisePoolChapterList.forEach(function (item) {
                    EChapterIds.push(item.HexID);
                    item.subChapterList.forEach(function (sub) {
                        EChapterIds.push(sub.HexID);
                        sub.subChapterList.forEach(function (sub2) {
                            EChapterIds.push(sub2.HexID);
                        })
                        if (parentEChapterId == sub.HexID) {
                            EChapterIds = EChapterIds.concat(newId);
                        }
                    })
                    if (parentEChapterId == item.HexID) {
                        EChapterIds = EChapterIds.concat(newId);
                    }
                })
            } else {
                //追加在最后
                _this.exercisePoolChapterList.forEach(function (item) {
                    EChapterIds.push(item.HexID);
                    item.subChapterList.forEach(function (sub) {
                        EChapterIds.push(sub.HexID);
                        sub.subChapterList.forEach(function (sub2) {
                            EChapterIds.push(sub2.HexID);
                        })
                    })
                })
                EChapterIds = EChapterIds.concat(newId);
            }
            tools.api('ExercisesPool.ChangeEChapterSequenceAsync', {
                "ExerciseContentsID": _this.exerciseContentsId,
                "EChapterIds": EChapterIds.join(",")
            }, (data) => {
                _this.getPoolChapter();
                tools.deleteLoading();
            });
        },
        clearCatalogValue: function () {
            $("textarea").val("");
            for (let oneChild of document.body.querySelectorAll('[data-shadow]')) {
                oneChild.removeAttribute('style')
            }
            this.isShowTextarea = false;
        },
        changeIsShowTextarea: function () {
            this.isShowTextarea = !this.isShowTextarea;
        },

        //添加新章
        showAddNewChapter: function (state) {
            this.visible = false
            if(state=='paper'){
                this.addHtepaperf = true
            }else{
                this.addHtepaperf = false
            }
            this.clearEditorChapterState();
            this.isAddNewChapter = true;
            this.addNewChapterName = "";
            this.addNewChapterPage = "";
            //默认光标选中
            this.$nextTick(function () {
                $('.content input[type="text"]').focus();
            })
        },
        closeAddNewChapter: function () {
            this.isAddNewChapter = false;
        },
        submitAddNewChapter: function () {
            let _this = this;
            let json = [{
                "EChapterName": _this.addNewChapterName,
                "EChapterGrade": 1,
                "PageStart": _this.isOCRExercisePool ? _this.addNewChapterPage : 0,
                "ParentEChapterId": 0,
              //  "Number":typeof (_this.exercisePoolChapterList.pop().Number)=="undefined"?0:_this.exercisePoolChapterList.pop().Number+1
            }];
            //页码规则校验,空校验
            let result = _this.submitAddChapterCheckCommon(json[0]);
            if (result.isCheck == false) {
                tools.alertwar(result.message);
                return false;
            }
            _this.closeAddNewChapter();
            //输入新章，滚动条自动向下
            _this.$nextTick(function () {
                $(".catalog").animate({scrollTop: $(".catalog")[0].scrollHeight}, 1000);
            })
           
            _this.savePoolChapterCommon(json, 0);
        },
        //页码规则校验,空校验
        submitAddChapterCheckCommon(json) {
            let _this = this;
            let minPage = 1;
            let maxPage = 0;

            let result = {"isCheck": true, "message": ""};
            if (json.EChapterName.length <= 0) {
                result.isCheck = false;
                result.message = "请输入章节名称!";
            } else if (_this.isOCRExercisePool && (json.PageStart.length <= 0 || parseInt(json.PageStart) == 0)) {
                result.isCheck = false;
                result.message = "请输入页码!";
            } else {
                //除第一次需要校验页码，其余的时候不校验。因为调序会乱掉，产品不好定
                // if (json.ParentEChapterId != 0) {
                //     //页码范围
                //     if (_this.exercisePoolChapterList.length > 0) {
                //         _this.exercisePoolChapterList.forEach(function (item, index) {
                //             if (item.HexID == json.ParentEChapterId) {
                //                 let minItem = item;
                //                 minItem.subChapterList.forEach(function (sub) {
                //                     minItem = sub;
                //                     sub.subChapterList.forEach(function (sub2) {
                //                         minItem = sub2;
                //                     })
                //                 })
                //                 minPage = parseInt(minItem.PageCount);
                //                 if (_this.exercisePoolChapterList[index + 1]) {
                //                     maxPage = parseInt(_this.exercisePoolChapterList[index + 1].PageCount);
                //                 }
                //             }
                //             item.subChapterList.forEach(function (sub, index2) {
                //                 if (sub.HexID == json.ParentEChapterId) {
                //                     let minItem = sub;
                //                     sub.subChapterList.forEach(function (sub2) {
                //                         minItem = sub2;
                //                     })
                //                     minPage = parseInt(minItem.PageCount);
                //                     if (item.subChapterList[index2 + 1]) {
                //                         maxPage = parseInt(item.subChapterList[index2 + 1].PageCount);
                //                     } else if (_this.exercisePoolChapterList[index + 1]) {
                //                         maxPage = parseInt(_this.exercisePoolChapterList[index + 1].PageCount);
                //                     }
                //                 }
                //             })
                //         })
                //     }
                // } else {
                //     if (_this.exercisePoolChapterList.length > 0) {
                //         //已有目录，则最小页码应该是已有最大页码
                //         let minItem = _this.exercisePoolChapterList[_this.exercisePoolChapterList.length - 1];
                //         minItem.subChapterList.forEach(function (sub) {
                //             minItem = sub;
                //             sub.subChapterList.forEach(function (sub2) {
                //                 minItem = sub2;
                //             })
                //         })
                //         minPage = parseInt(minItem.PageCount);
                //     }
                // }
                //
                // if (!(json.PageStart >= minPage)) {
                //     result.isCheck = false;
                //     result.message = "请填写正确页码!";
                // }
                // if (maxPage != 0) {
                //     if (!(json.PageStart <= maxPage)) {
                //         result.isCheck = false;
                //         result.message = "请填写正确页码!";
                //     }
                // }
                //
                // console.log(minPage, maxPage);
            }

            return result;
        },
        //编辑旧章
        showEditorChapter: function (item) {
            let _this = this;
            _this.clearEditorChapterState();
            item.isEditorChapter = true;
            this.$nextTick(function () {
                $('.content input[type="text"]').focus();
            })
        },
        submitEditorChapter: function (item) {
            let _this = this;

            let json = {
                "EChapterName": item.HexName,
                "EChapterId": item.HexID,
                "PageStart": item.PageCount,
            };
            //页码规则校验,空校验
            let result = _this.submitAddChapterCheckCommon(json);
            if (result.isCheck == false) {
                tools.alertwar(result.message);
                return false;
            }

            tools.api('ExercisesPool.UpdateEChapterAsync', json, (data) => {
                item.isEditorChapter = false;
            });
        },
        delEditorChapterr: function (item) {
            window.burryPointHandler({'echapterId': item.HexID}, 'UCT2_4_3')
            let _this = this;
            tools.api('ExercisesPool.EchapterHaveExercise', {
                "echapterId": item.HexID
            }, (data) => {
              console.log(data)
              let isHaveExercise = tools.cloneJson(data)
              if(isHaveExercise) {
                _this.$confirm(`该${item.level != 1 ? '节' : '章'}下存在习题，请确认是否删除?`, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning',
                  }).then(() => {
                    tools.api('ExercisesPool.DeleteEChapterAsync', {
                        "exercisePoolId": _this.exercisePoolId,
                        "eChapterIdList": [item.HexID]
                    }, (data) => {
                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        item.isEditorChapter = false;
                        _this.getPoolChapter();
                    });
                  }).catch(() => {
                   
                  });
              } else {
                tools.api('ExercisesPool.DeleteEChapterAsync', {
                    "exercisePoolId": _this.exercisePoolId,
                    "eChapterIdList": [item.HexID]
                }, (data) => {
                    _this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    item.isEditorChapter = false;
                    _this.getPoolChapter();
                });
              }
            });
           
        },
        //添加子节
        addEditorChapter: function (item) {
            let _this = this;
            _this.clearEditorChapterState();
            item.isAddSubChapter = true;
            this.addSubChapterName = "";
            this.addSubChapterPage = "";
            this.$nextTick(function () {
                $('.content input[type="text"]').focus();
            })
        },
        closeAddEditorChapter: function (item) {
            item.isAddSubChapter = false;
        },
        submitAddSubChapter: function (item) {
            //console.log(item)

            //console.log(item.subChapterList.pop());
            let _this = this;
            let json = [{
                "EChapterName": _this.addSubChapterName,
                "EChapterGrade": item.Grade + 1,
                "PageStart": _this.isOCRExercisePool ? _this.addSubChapterPage : 0,
                "ParentEChapterId": item.HexID,
               // "Number":typeof(item.subChapterList.pop())=="undefined"?0:item.subChapterList.pop().Number+1
            }];
         
            //页码规则校验,空校验
            let result = _this.submitAddChapterCheckCommon(json[0]);
            if (result.isCheck == false) {
                tools.alertwar(result.message);
                return false;
            }
            _this.closeAddEditorChapter(item);
            _this.savePoolChapterCommon(json, item.HexID);
        },
        //编辑框操作互斥，所以要清除所有编辑状态
        clearEditorChapterState: function () {
            let _this = this;
            //编辑框要做成互斥的
            _this.isAddNewChapter = false;
            _this.exercisePoolChapterList.forEach(function (item) {
                item.isEditorChapter = false;
                item.isAddSubChapter = false;
                item.subChapterList.forEach(function (sub) {
                    sub.isEditorChapter = false;
                    sub.isAddSubChapter = false;
                    sub.subChapterList.forEach(function (sub2) {
                        sub2.isEditorChapter = false;
                    })
                })
            })
        },
        //=====右键操作start=======
        rightClick: function ($ev, one, grade) {
            let $this = $ev.target;
            let Left = $this.offsetLeft;
            let Top = $this.offsetTop;
            let width = $this.offsetWidth;
            let height = $this.offsetHeight;

            let _this = this;
            _this.isShowContextMenu = true;
            _this.contextMenuLeft = width / 2;
            _this.contextMenuTop = Top + height / 2;
            _this.contextMenuOne = one;
            _this.contextMenuGrade = grade;
            _this.contextMenuDom = $this;
        },
        //插入章节 before\after
        insertEditorChapter: function (item, direction) {
            let _this = this;
            _this.contextMenuDirection = direction;
            let textplaceholder = "";
            if (_this.contextMenuGrade == 1) {
                textplaceholder = "请输入章名称";
            } else if (_this.contextMenuGrade == 2) {
                textplaceholder = "请输入节名称";
            } else if (_this.contextMenuGrade == 3) {
                textplaceholder = "请输入小节名称";
            }
            $("#insert").remove();
            let html = '<div id="insert" class="editorchapter">' +
                '<input type="text" placeholder="' + textplaceholder + '" hex-text=""></input>' +
                '<input type="num" placeholder="页码" hex-num=""></input>' +
                '<a class="chapter submit" hex-add=""></a>' +
                '<a class="chapter del" hex-del=""></a>' +
                '</div>';

            let $this = _this.contextMenuDom;
            //找到节点
            if (!$($this).hasClass("chapter")) {
                $this = $($this).parents(".chapter").first();
            }
            if (direction == "before") {
                $(html).insertBefore($this)
            } else {
                $(html).insertAfter($this)
            }

            if (!_this.isOCRExercisePool) {
                $("#insert [hex-num]").val(0).hide();
            }

            _this.insertEditorChapterDom();
        },
        //插入章节dom操作
        insertEditorChapterDom: function () {
            let _this = this;

            $(document.body).off("click", "#insert [hex-del]");
            $(document.body).on("click", "#insert [hex-del]", function () {
                $("#insert").remove();
            });

            $(document.body).off("click", "#insert [hex-add]");
            $(document.body).on("click", "#insert [hex-add]", function () {
                let text = $("#insert [hex-text]").val();
                let num = $("#insert [hex-num]").val();
                let json ='';
              
                if(_this.contextMenuDirection=='before'){
                    json = [{
                        "EChapterName": text,
                        "EChapterGrade": _this.contextMenuGrade,
                        "PageStart": num,
                        "ParentEChapterId": _this.contextMenuOne.ParentID,
                        "Sequence":_this.contextMenuOne.Sequence
                       // "Number":_this.contextMenuOne.Number==0?0:_this.contextMenuOne.Number-1
                    }];
                }else{
                    json = [{
                        "EChapterName": text,
                        "EChapterGrade": _this.contextMenuGrade,
                        "PageStart": num,
                        "ParentEChapterId": _this.contextMenuOne.ParentID,
                        "Sequence":_this.contextMenuOne.Sequence+1
                      //  "Number":_this.contextMenuOne.Number+1
                    }];
                }
                //页码规则校验,空校验
                let result = _this.submitAddChapterCheckCommon2(json[0]);
                if (result.isCheck == false) {
                    tools.alertwar(result.message);
                    return false;
                }
                $("#insert").remove();
                _this.savePoolChapterCommon2(json);
            });
        },
        submitAddChapterCheckCommon2(json) {
            let _this = this;
            let minPage = 1;
            let maxPage = 0;

            let result = {"isCheck": true, "message": ""};
            if (json.EChapterName.length <= 0) {
                result.isCheck = false;
                result.message = "请输入章节名称!";
            } else if (_this.isOCRExercisePool && (json.PageStart.length <= 0 || parseInt(json.PageStart) == 0)) {
                result.isCheck = false;
                result.message = "请输入页码!";
            } else {
                //除第一次需要校验页码，其余的时候不校验。因为调序会乱掉，产品不好定

                // if (_this.contextMenuDirection == "before") {
                //     //向上插入  则 当前项>=page>=当前项前一项
                //     let exercisePoolChapterList = [];
                //     for (let item of _this.exercisePoolChapterList) {
                //         exercisePoolChapterList.push(item);
                //         for (let sub of item.subChapterList) {
                //             exercisePoolChapterList.push(sub);
                //             for (let sub2 of sub.subChapterList) {
                //                 exercisePoolChapterList.push(sub2);
                //             }
                //         }
                //     }
                //     let index = exercisePoolChapterList.indexOf(_this.contextMenuOne);
                //     if (exercisePoolChapterList[index - 1]) {
                //         minPage = parseInt(exercisePoolChapterList[index - 1].PageCount);
                //     }
                //     maxPage = parseInt(_this.contextMenuOne.PageCount);
                // } else if (_this.contextMenuDirection == "after") {
                //     //向后插入 则 当前项最后一个子节点<=page<=当前项下一个同等级的项
                //     _this.exercisePoolChapterList.forEach(function (item, index) {
                //         if (item.HexID == _this.contextMenuOne.HexID) {
                //             let minItem = item;
                //             minItem.subChapterList.forEach(function (sub) {
                //                 minItem = sub;
                //                 sub.subChapterList.forEach(function (sub2) {
                //                     minItem = sub2;
                //                 })
                //             })
                //             minPage = parseInt(minItem.PageCount);
                //             if (_this.exercisePoolChapterList[index + 1]) {
                //                 maxPage = parseInt(_this.exercisePoolChapterList[index + 1].PageCount);
                //             }
                //         }
                //         item.subChapterList.forEach(function (sub, index2) {
                //             if (sub.HexID == _this.contextMenuOne.HexID) {
                //                 let minItem = sub;
                //                 sub.subChapterList.forEach(function (sub2) {
                //                     minItem = sub2;
                //                 })
                //                 minPage = parseInt(minItem.PageCount);
                //                 if (item.subChapterList[index2 + 1]) {
                //                     maxPage = parseInt(item.subChapterList[index2 + 1].PageCount);
                //                 } else if (_this.exercisePoolChapterList[index + 1]) {
                //                     maxPage = parseInt(_this.exercisePoolChapterList[index + 1].PageCount);
                //                 }
                //             }
                //         })
                //     })
                // }
                //
                // if (!(json.PageStart >= minPage)) {
                //     result.isCheck = false;
                //     result.message = "请填写正确页码!";
                // }
                // if (maxPage != 0) {
                //     if (!(json.PageStart <= maxPage)) {
                //         result.isCheck = false;
                //         result.message = "请填写正确页码!";
                //     }
                // }
                //
                // console.log(minPage, maxPage);
            }
            return result;
        },
        savePoolChapterCommon2: function (list) {
            let _this = this;
            window.burryPointHandler({
                "exerciseBookId":_this.exercisePoolId,
                "eChapterName":list[0].EChapterName,
                "parentEChapterID":list[0].ParentEChapterId,
                "grade":list[0].EChapterGrade,
                "pageStart":list[0].PageStart,
                "Sequence":list[0].Sequence
            }, 'UCT2_4_2')
            let json = {}; 
            tools.putLoading();
            json={
                "exerciseBookId":_this.exercisePoolId,
                "eChapterName":list[0].EChapterName,
                "parentEChapterID":list[0].ParentEChapterId,
                "grade":list[0].EChapterGrade,
                "pageStart":list[0].PageStart,
                "Sequence":list[0].Sequence
            }
            tools.api('ExercisePools.CreateEChapter', json, (data) => {
               
               // _this.changeEChapterSequence(data, parentEChapterId);
               _this.getPoolChapter();
               tools.deleteLoading();
            });
        },
        //章节排序接口，只有添加章节时调用
        changeEChapterSequence2: function (newId) {
            let _this = this;
            let EChapterIds = [];

            if (_this.contextMenuDirection == "before") {
                let exercisePoolChapterList = [];
                for (let item of _this.exercisePoolChapterList) {
                    exercisePoolChapterList.push(item);
                    for (let sub of item.subChapterList) {
                        exercisePoolChapterList.push(sub);
                        for (let sub2 of sub.subChapterList) {
                            exercisePoolChapterList.push(sub2);
                        }
                    }
                }
                for (let item of exercisePoolChapterList) {
                    if (item.HexID == _this.contextMenuOne.HexID) {
                        EChapterIds.push(newId);
                    }
                    EChapterIds.push(item.HexID);
                }
            } else if (_this.contextMenuDirection == "after") {
                _this.exercisePoolChapterList.forEach(function (item, index) {
                    EChapterIds.push(item.HexID);
                    if (item.HexID == _this.contextMenuOne.HexID) {
                        item.subChapterList.forEach(function (sub) {
                            EChapterIds.push(sub.HexID);
                            sub.subChapterList.forEach(function (sub2) {
                                EChapterIds.push(sub2.HexID);
                            })
                        })
                        EChapterIds.push(newId);
                    } else {
                        item.subChapterList.forEach(function (sub, index2) {
                            EChapterIds.push(sub.HexID);
                            if (sub.HexID == _this.contextMenuOne.HexID) {
                                sub.subChapterList.forEach(function (sub2) {
                                    EChapterIds.push(sub2.HexID);
                                })
                                EChapterIds.push(newId);
                            } else {
                                sub.subChapterList.forEach(function (sub2) {
                                    EChapterIds.push(sub2.HexID);
                                    if (sub2.HexID == _this.contextMenuOne.HexID) {
                                        EChapterIds.push(newId);
                                    }
                                })
                            }
                        })
                    }
                })
            }


            tools.api('ExercisesPool.ChangeEChapterSequenceAsync', {
                "ExerciseContentsID": _this.exerciseContentsId,
                "EChapterIds": EChapterIds.join(",")
            }, (data) => {
                _this.getPoolChapter();
                tools.deleteLoading();
            });
        },
        //=========右键操作end========

        //=========拖拽操作start========
        onStart(evt) {
            this.drag = true;
            // let e = evt || window.event;
            // let chosen = document.querySelector('.sortable-fallback')
            // chosen.style.top = e.item.offsetTop + 'px';
        },
        onEnd(e) {
            let that = this;
            
            //拖拽完成后，exercisePoolChapterList里的数据顺序会改变
            // console.log(this.exercisePoolChapterList);
      

            let _this = this;
            //章节目录调序(2级变1级,3级变2级、1级不变)
            let ParentID = _this.dragItem.ParentID;
            for (let item of _this.exercisePoolChapterList) {
                if (_this.dragItem.HexID == item.HexID) {
                    ParentID = 0;
                }
                for (let sub of item.subChapterList) {
                    if (_this.dragItem.HexID == sub.HexID) {
                        ParentID = item.HexID;
                    }
                    for (let sub2 of sub.subChapterList) {
                        if (_this.dragItem.HexID == sub2.HexID) {
                            ParentID = sub.HexID;
                        }
                    }
                }
            }
            console.log(this.exercisePoolChapterList)

            function recursion(data, loadID){
                var result = null;
                if(!data){
                   // return; 中断执行
                   return;
                }
                for(var i in data){
                    if(result!==null){
                        break;
                    }
                    var item = data[i];
                  //  console.log(item)
                    if(item.HexID == loadID){
                        result = item;
                      //  console.log(item);
                        break;
                    }else if(item.subChapterList && item.subChapterList.length > 0){
                        result = recursion(item.subChapterList, loadID);
                    }
                }
                return result;
            }
            
           // console.log(this.exercisePoolChapterList,this.ParentId)
            var newarr = recursion(this.exercisePoolChapterList,this.ParentId)
           
            if(newarr==null){
                var index = this.exercisePoolChapterList.findIndex(function(val){
                    return val.HexID === that.EChapterId 
                })
              
                that.Sequence = index;
            }else{
                var index = newarr.subChapterList.findIndex(function(val){
                    return val.HexID === that.EChapterId 
                })
                that.Sequence = index;
           
            }
            tools.api('ExercisesPool.ChangeEChapterSequenceAsync', {
                "EChapterId": that.EChapterId,
                "ParentId": that.ParentId,
                "Sequence":that.Sequence+1,
              //  "Grade":that.Grade,
                "ExercisePoolID":that.exercisePoolId
            }, (data) => {
                that.getPoolChapter();
            });
            this.drag = false;

        },
        //move回调方法
        onMove(e, originalEvent) {
            /*e对象结构
            draggedContext: 被拖拽的元素
                index: 被拖拽的元素的序号
                element: 被拖拽的元素对应的对象
                futureIndex: 预期位置、目标位置
            relatedContext: 将停靠的对象
                index: 目标停靠对象的序号
                element: 目标的元素对应的对象
                list:  目标数组
                component: 将停靠的vue组件对象
            */

            if (e.draggedContext.element.level < e.relatedContext.element.level) {
                return false;
            }else{
                this.EChapterId = e.draggedContext.element.HexID;
                this.ParentId = e.relatedContext.element.ParentID;
               // this.Grade = e.relatedContext.element.Grade;
                this.dragItem = e.draggedContext.element;
                window.burryPointHandler(
                    {
                        'EChapterId': this.EChapterId,
                        'ParentId': this.ParentId,
                        'dragItem':  this.dragItem
                    }, 
                    'UCT2_4_4'
                )
                return true;
            }
            
        },
        //=========拖拽操作end========


        //=========与之交互start===========
        //改变章节
        changeChapterComponents: function () {
            const _this = this;

            //获取节名称
            let activeChapterName = "";
            let activeChapterNameList = [];
            for (let item of _this.exercisePoolChapterList) {
                activeChapterNameList.push(item);
                for (let sub of item.subChapterList) {
                    activeChapterNameList.push(sub);
                    for (let sub2 of sub.subChapterList) {
                        activeChapterNameList.push(sub2);
                    }
                }
            }
            for (let item of activeChapterNameList) {
                if (_this.activeChapterId == item.HexID) {
                    activeChapterName = item.HexName
                }
            }

            _this.$emit('changeChapterComponents', _this.activeChapterId, activeChapterName);
        },
        changeEditorCatalogComponents: function () {
            const _this = this;
            _this.$emit('changeEditorCatalogComponents', _this.isEditorCatalog);
        },
        //获取章节的子节
        getSubChapterList: function () {
            let _this = this;
            //查看习题，章id需要传所有子节点id
            let activeChapterId = _this.activeChapterId;
            let activeChapterIdList = [_this.activeChapterId];
            for (let item of _this.exercisePoolChapterList) {
                if (activeChapterId == item.HexID) {
                    for (let sub of item.subChapterList) {
                        activeChapterIdList.push(sub.HexID);
                        for (let sub2 of sub.subChapterList) {
                            activeChapterIdList.push(sub2.HexID);
                        }
                    }
                } else {
                    for (let sub of item.subChapterList) {
                        if (activeChapterId == sub.HexID) {
                            for (let sub2 of sub.subChapterList) {
                                activeChapterIdList.push(sub2.HexID);
                            }
                        }
                    }
                }
            }
            return activeChapterIdList;
        },
        //获取是否是编辑目录状态
        getIsEditorCatalog: function () {
            return this.isEditorCatalog
        },
        //=========与之交互end===========

        //根据章节下是否有附件进行事件分离
        isvoicechp(id){
            let _this = this;
            if(_this.activeChapterId!=0&&_this.activeChapterId!=-1 &&_this.activeChapterId==id){
                tools.api('ExercisesPool.SeachResourceByEChapterID', {
                    echapterId:_this.activeChapterId,
                }, (data) => {
                    if(data.length==0){
                        _this.voiceshow = true;
                        _this.havevoice = false
                    }else{
                        _this.voiceshow = true;
                        _this.havevoice = true
                        _this.linkvoice = data[0].AttachedFileName
                        _this.linkvoiceId = data[0].AttachedId
                    }
                });
            }
        },
        showallvoice(e){
            this.$emit('showallvoice_f', e.HexID);
        },
        //解除音频关联
        delvoice(){
            let _this = this;
            this.$emit('delvoice_f', _this.activeChapterId,_this.linkvoiceId);
        },
        //查询题库下是否有音频
        checkallVoice(){
            tools.api('ExercisesPool.SeachAttacheFiledListByExercisePoolID', {
                exercisePoolId:this.exercisePoolId,
            }, (data) => {
                if (data.length==0) {
                    this.allhavevoicebank = false
                }else{
                    this.allhavevoicebank = true
                }
            });
        },
        // 勾选章节复选框处理 type 0非编辑状态 1编辑状态
        chooseChapter(type = 0, el, sub = null, sub2 = null) {
            if (sub2 != null) {
                let checkbox = document.querySelectorAll(`.itemCheck[value="${sub2.HexID}"]`)[type]
                document.querySelectorAll(`.itemCheck[value="${sub2.HexID}"]`)[1-type].checked = checkbox.checked
                if (!checkbox.checked) {
                    // 取消选中了当前章节
                    // 如果父节点是选中的 取消选中父节点
                    if (document.querySelector(`.itemCheck[value="${sub.HexID}"]`).checked) {
                        document.querySelectorAll(`.itemCheck[value="${sub.HexID}"]`).forEach(box => box.checked = false)
                    }
                    // 如果更上级节点是选中的 取消选中更上级节点
                    if (document.querySelector(`.itemCheck[value="${el.HexID}"]`).checked) {
                        document.querySelectorAll(`.itemCheck[value="${el.HexID}"]`).forEach(box => box.checked = false)
                    }
                }
            } else if (sub != null) {
                let checkbox = document.querySelectorAll(`.itemCheck[value="${sub.HexID}"]`)[type]
                document.querySelectorAll(`.itemCheck[value="${sub.HexID}"]`)[1-type].checked = checkbox.checked
                if (!checkbox.checked) {
                    // 取消选中了当前章节
                    // 如果有子节点 则全部取消选中
                    sub.subChapterList.forEach(item => {
                        document.querySelectorAll(`.itemCheck[value="${item.HexID}"]`).forEach(box => box.checked = false)
                    })
                    // 如果更上级节点是选中的 取消选中更上级节点
                    if (document.querySelector(`.itemCheck[value="${el.HexID}"]`).checked) {
                        document.querySelectorAll(`.itemCheck[value="${el.HexID}"]`).forEach(box => box.checked = false)
                    }
                } else {
                    // 选中了当前章节
                    // 如果有子节点 则全部选中
                    sub.subChapterList.forEach(item => {
                        document.querySelectorAll(`.itemCheck[value="${item.HexID}"]`).forEach(box => box.checked = true)
                    })
                }
            } else {
                let checkbox = document.querySelectorAll(`.itemCheck[value="${el.HexID}"]`)[type]
                document.querySelectorAll(`.itemCheck[value="${el.HexID}"]`)[1-type].checked = checkbox.checked
                if (!checkbox.checked) {
                    // 取消选中了当前章节
                    // 如果有子节点 则全部取消选中
                    el.subChapterList.forEach(item => {
                        document.querySelectorAll(`.itemCheck[value="${item.HexID}"]`).forEach(box => box.checked = false)
                        item.subChapterList.forEach(item2 => {
                            document.querySelectorAll(`.itemCheck[value="${item2.HexID}"]`).forEach(box => box.checked = false)
                        })
                    })
                } else {
                    // 如果有子节点 则全部选中
                    el.subChapterList.forEach(item => {
                        document.querySelectorAll(`.itemCheck[value="${item.HexID}"]`).forEach(box => box.checked = true)
                        item.subChapterList.forEach(item2 => {
                            document.querySelectorAll(`.itemCheck[value="${item2.HexID}"]`).forEach(box => box.checked = true)
                        })
                    })
                }
            }
        },

        // 批量删除章节
        batchDelChapters() {
            let _this = this;
            let choosedNodes = document.querySelectorAll('input.itemCheck:checked')
            let hexids = []
            choosedNodes.forEach(oneNode => {
               let hexid = oneNode.getAttribute('value')
               hexids.push(hexid)
            })
            hexids = [...new Set(hexids)]
            if (hexids.length) {
                _this.$confirm(`请确认是否进行章节批量删除操作?`, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning',
                  }).then(() => {
                    tools.api('ExercisesPool.DeleteEChapterAsync', {
                        "exercisePoolId": _this.exercisePoolId,
                        "eChapterIdList": hexids
                    }, (data) => {
                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        _this.getPoolChapter();
                    });
                  }).catch(() => {
                   
                  });
            } else {
                _this.$message({
                    type: 'warning',
                    message: '请勾选要删除的章节!'
                })
            }
        }
    }
}